import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getInvTSByID = (inv_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_TS}` + `/by-inv-id/${inv_id}`);
};
export const billing_expense_addInvTS = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_TS}` + `/create`, data);
};
export const billing_expense_deleteInvTS = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_TS}` + `/delete/${id}`);
};

export const billing_expense_getAllInvTSBytimesheetCreeper_hid = (data) => {
    return httpClient.post(
        `${billing_expense.billing_expense_url}/${server.INVOICE_TS}` + `/detail_timesheetCreeper_hid`,
        data
    );
};